<section class="check-registration-company">
  <div class="box">
    <div class="left">
      <div class="img-wrapper" (click)="linkVideo('-WzPs5EgTyo')" data-toggle="modal" data-target="#functionVideo">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/Seminar/Flowacademy/Banner/flow_knowledge_ep1.webp"
            type="image/webp"
          />
          <source
            srcset="https://flowaccountcdn.com/Seminar/Flowacademy/Banner/flow_knowledge_ep1.jpg"
            type="image/png"
          />
          <img
          src="https://flowaccountcdn.com/Seminar/Flowacademy/Banner/flow_knowledge_ep1.jpg"
          class="img-cover"
          alt="รับจดทะเบียนบริษัท"
          title="รับจดทะเบียนบริษัท"
          loading="lazy"
        />
      </picture>

      <div class="icon-wrapper">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
            type="image/webp"
          />
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
            type="image/jpeg"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
            class="icon-play"
            alt="รับจดทะเบียนบริษัท"
            title="รับจดทะเบียนบริษัท"
            loading="lazy"
          />
        </picture>
      </div>
      </div>
    </div>

    <div class="right">
      <h2 class="title desktop"[innerHtml]="'BUSINESS_REGISTRATION.REGISTER_COMPANY.TITLE' | translate"></h2>
      <h2 class="title mobile"[innerHtml]="'BUSINESS_REGISTRATION.REGISTER_COMPANY.TITLE_MOBILE' | translate"></h2>
      <div class="description" [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_COMPANY.DESCRIPTION' | translate"> </div>
      <div class="btn-wrapper">
        <button class="btn-video" (click)="linkVideo('dpKxcxlK9Ko')">
          <i class="far fa-play-circle" aria-hidden="true"></i>
          <span class="text" [innerHtml]="'BUSINESS_REGISTRATION.REGISTER_COMPANY.BUTTON' | translate"></span>
        </button>
      </div>
    </div>
  </div>
</section>
